// extracted by mini-css-extract-plugin
export var menuIcon = "_pr-0";
export var menuIconInline = "_pr-1";